<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

const i18nHead = useLocaleHead()
const { data } = useCurrentLive()

useMaintenance()
useBuildVersion()
useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang,
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])],
}))
</script>

<template>
  <NuxtErrorBoundary>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <template #error="{ error, clearError }">
      <ErrorBoundary
        :error="error"
        :status-code="HttpStatusCode.InternalServerError"
        @clear="clearError()"
      />
    </template>
  </NuxtErrorBoundary>

  <LazyStreamObserver v-if="data?.isObs || data?.isUseHostApp" :data="data" />
  <LazyStreamActivityBar
    v-if="data?.status === StreamStatus.LIVE"
    :data="data"
  />

  <LazyIdleToaster hydrate-on-idle />
  <LazyIdleGlobalAlertDialog hydrate-on-idle />
  <VueQueryDevtools button-position="bottom-left" />
</template>
